import React from "react";
import { withRouter } from "react-router-dom";
import withDefaultParams from "Services/withDefaultParams";
import { variablesFromRouter } from "Services/QueryBuilder";
import { useQuery } from "@apollo/client";
import { inject, observer } from "mobx-react";
import { v4 } from "uuid";
import { DECLINATION_QUERY } from "Configs/queries";
import {
    TARIFFS_BEST_HOUSE_QUERY_V2,
    HOUSE_FULL_QUERY_V3,
} from "Services/queries";

const SeoAddressContainer = props => {
    let {
        match: {
            params: { regionUrl },
        },
        variables,
    } = props;

    const houseFullQuery = useQuery(HOUSE_FULL_QUERY_V3, {
        skip: !props.variables.houseId,
        variables: {
            id: parseInt(variables.houseId),
        },
    });
    const houseFull = houseFullQuery?.data?.houseFullV3;

    const declination = useQuery(DECLINATION_QUERY, {
        variables: {
            filter: `url=${regionUrl}`,
        },
    });
    const declinations = declination?.data?.region?.declinations;

    const tariffsBest = useQuery(TARIFFS_BEST_HOUSE_QUERY_V2, {
        skip: !props.variables.houseId,
        variables: {
            ...props.variables,
            filter: `region.url=${props.variables.region_url}`,
        },
    });
    const tariffsBestByHouse = tariffsBest?.data?.tariffsBestByHouseV2;

    if (
        houseFull?.address_id &&
        declination?.data?.region &&
        tariffsBestByHouse &&
        tariffsBestByHouse?.lowCost &&
        tariffsBestByHouse?.highSpeed
    ) {
        const addressFullName = houseFull?.address_full;

        let txt;
        if (tariffsBestByHouse?.lowCost?.length === 1) {
            txt = `Адрес ${addressFullName} обслуживает только интернет-провайдер ${tariffsBestByHouse?.lowCost.map(
                t => t.provider.name
            )}`;
        } else {
            txt = `Интернет-провайдеры, которые обслуживают адрес ${addressFullName}: ${tariffsBestByHouse?.lowCost
                .map(t => t.provider.name)
                .join(", ")}`;
        }

        const text1 = `Проверка интернет-операторов, которые есть в доме по адресу ${addressFullName} в ${declinations?.prepositional}`;
        const text2 = `1. Какие провайдеры подключают интернет по адресу ${addressFullName} в ${declinations?.prepositional}?`;
        const text3 = `2. Какие самые недорогие тарифы на услуги подключения интернета по адресу ${addressFullName}?`;
        const text4 = `3. Какое самое быстрое интернет-соединение доступно на ${addressFullName}?`;

        return (
            <>
                <h2>{text1}</h2>
                <p>{text2}</p>
                <ul>
                    <li>{txt}</li>
                    <li>
                        С помощью нашего сервиса вы сможете найти провайдера,
                        узнать сколько будет стоит провести домашний интернет +
                        ТВ и подключиться
                    </li>
                </ul>
                <p>{text3}</p>

                <ul>
                    {tariffsBestByHouse?.lowCost.map(t => {
                        const txt = `${t.name} от интернет-оператора ${t.provider.name} по цене ${t.displayPrice} р/мес`;
                        return <li key={v4()}>{txt}</li>;
                    })}
                </ul>

                <p>{text4}</p>
                <p>Лучше всего работает сеть следующих операторов: </p>

                <ul>
                    {tariffsBestByHouse?.highSpeed.map(t => {
                        if (t.internet) {
                            const txt = `${t.name} от интернет-оператора ${t.provider.name} со скоростью ${t.internet.speed_in} мбит/с`;
                            return <li key={v4()}>{txt}</li>;
                        } else {
                            return "";
                        }
                    })}
                </ul>
                <p>
                    Узнайте можно ли провести WiFi в ваш дом на бесплатной
                    консультации по телефону, помощь в подборе тарифа и
                    оформления заявок на подключение.
                </p>
            </>
        );
    } else {
        return null;
    }
};

export default withRouter(
    withDefaultParams(
        variablesFromRouter(
            inject("ApplicationModel")(observer(SeoAddressContainer))
        )
    )
);
